import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import history from "../utils/history";
import LandingPage from "../pages/LandingPage";
import Signup from "../pages/AuthScreens/signup";
import Signin from "../pages/AuthScreens/signin";
import Dashboard from "../pages/Dashboard";
import NewProject from "../pages/NewProjectPage";
import ProjectPage from "../pages/ProjectPage";

const Routers = () => {
  return (
    <Router browserHistory={history}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/home/:id" element={<Dashboard />} />
        <Route path="/newproject/:id" element={<NewProject />} />
        <Route path="/project/:id&:pid" element={<ProjectPage />} />
      </Routes>
    </Router>
  );
};

export default Routers;
